import { buffer } from 'rxjs/operators';
import { MunicipalityModel } from 'src/app/shared/models/municipality.model';
import { LanguageType } from './enum.model';

export class BuildingModel {
  id: string;
  construction: Date;
  longitude: number;
  latitude: number;
  street: string;
  streetNumber: string;
  municipality: MunicipalityModel;
  municipalityId: string;
  language: LanguageType;

  cO2: BuildingCO2;
  details: BuildingDetails;
  energy: BuildingEnergy;
  geometry: BuildingGeometry;
  investment: BuildingInvestment;
  moneySaving: BuildingMoneySaving;
  co: BuildingCO;
  consumation: BuildingConsumation;
  dust: BuildingDust;
  nmvoc: BuildingNMVOC;
  nox: BuildingNOx;
  pricePerInvestment: BuildingPricePerInvestment;
  profitability: BuildingProfitability;
  sO2: BuildingSO2;

  constructor() {
    this.longitude = 0;
    this.latitude = 0;

    this.cO2 = new BuildingCO2();
    this.details = new BuildingDetails();
    this.energy = new BuildingEnergy();
    this.geometry = new BuildingGeometry();
    this.investment = new BuildingInvestment();
    this.moneySaving = new BuildingMoneySaving();
    this.co = new BuildingCO();
    this.consumation = new BuildingConsumation();
    this.dust = new BuildingDust();
    this.nmvoc = new BuildingNMVOC();
    this.nox = new BuildingNOx();
    this.pricePerInvestment = new BuildingPricePerInvestment();
    this.profitability = new BuildingProfitability();
    this.sO2 = new BuildingSO2();
  }
}

export class BuildingCO2 {
  transmision: number;
  decreaseByWallsIsolation: number;
  decreaseByRoofsIsolation: number;
  decreaseByWindowsIsolation: number;
  decreaseByGroundIsolation: number;
  sumDecrease: number;

  constructor() {
    this.transmision = 0;
    this.decreaseByWallsIsolation = 0;
    this.decreaseByRoofsIsolation = 0;
    this.decreaseByWindowsIsolation = 0;
    this.decreaseByGroundIsolation = 0;
    this.sumDecrease = 0;
  }
}

export class BuildingDetails {
  archiveDate: string;
  municipality: string;
  addressStreet: string;
  addressNumber: string;
  floors: number;
  apartments: number;
  yearOfBuild: string;
  lastYearRenovation: string;
  partInPercentage: string;
  apartmentsForRent: string;
  apartmentsForRentDetails: string;
  buildingManagementType: string;
  managementContact: string;
  archiveNumber1: string;
  archiveDate1: string;
  managementName: string;
  municipality1: string;
  region: string;
  addressStreet1: string;
  addressNumber1: string;
  contractNumber: string;
  height: string;
  length: string;
  width: string;
  entrances: number;
  apartmentsByFloor: string;
  apartmentArea: string;
  emptyApartments: string;
  officeSpace: string;
  officeSpaceDescription: string;
  hasElevator: string;
  elevatorDescription: string;
  elevatorState: string;
  elevatorMaintenanceCompany: string;
  elevatorMaintenanceCompanyContact: string;
  hasCommonSpace: string;
  commonSpaceDescription: string;
  isLandPrivatize: string;
  wallsType: string;
  constructionBetweenFloors: string;
  roofType: string;
  roofCovering: string;
  northBuildingArea: number;
  southBuildingArea: number;
  eastBuildingArea: number;
  westBuildingArea: number;
  roofState: string;
  facadeState: string;
  windowsState: string;
  entranceDoorState: string;
  waysOfHeating: string;
  aparmentsExcludedFromCentralHeating: string;
  hasAntiFireLaddersAndWorks: string;
  hasHydrantAndWorks: string;
  hasAntiFireDeviceAndWorks: string;
  hasSsrPeople: string;
  ssrPeople: number;
  accessRampForSsrPeople: string;
  hasLightningRod: string;
  isOkLightningRod: string;
  notes: string;
  responsibleDataPerson: string;

  constructor() {
    this.floors = 0;
    this.northBuildingArea = 0;
    this.southBuildingArea = 0;
    this.eastBuildingArea = 0;
    this.westBuildingArea = 0;
  }
}

export class BuildingEnergy {
  yearlyRequredEnergy: number;
  yearlyRequredEnergyAfterWallsIsolation: number;
  yearlyRequredEnergyAfterRoofIsolation: number;
  yearlyRequredEnergyAfterWindowIsolation: number;
  yearlyRequredEnergyAfterGroundIsolation: number;
  yearlyRequredEnergyAfterAllMeasures: number;
  wallsIsolationSaving: number;
  roofsIsolationSaving: number;
  windowsIsolationSaving: number;
  groundIsolationSaving: number;
  sumIsolationSaving: number;
  energyType: string;
  buildingEnergyClass: string;
  buildingEnergyClassAfterAllMeasures: string;
  yearlyRequredEnergyPerM2: number;
  yearlyRequredEnergyPerM2AfterAllMeasures: number;

  constructor() {
    this.yearlyRequredEnergy = 0;
    this.yearlyRequredEnergyAfterWallsIsolation = 0;
    this.yearlyRequredEnergyAfterRoofIsolation = 0;
    this.yearlyRequredEnergyAfterWindowIsolation = 0;
    this.yearlyRequredEnergyAfterGroundIsolation = 0;
    this.yearlyRequredEnergyAfterAllMeasures = 0;
    this.wallsIsolationSaving = 0;
    this.roofsIsolationSaving = 0;
    this.windowsIsolationSaving = 0;
    this.groundIsolationSaving = 0;
    this.sumIsolationSaving = 0;
    this.yearlyRequredEnergyPerM2 = 0;
    this.yearlyRequredEnergyPerM2AfterAllMeasures = 0;
  }
}

export class BuildingGeometry {
  area: number;
  basePerimetar: number;
  floors: string;
  facadeArea: number;
  windowArea: number;
  basement: string;
  heatedBases: number;
  volume: number;
  formFactor: number;
  branchingFactorBasically: number;

  constructor() {
    this.area = 0;
    this.basePerimetar = 0;
    this.facadeArea = 0;
    this.windowArea = 0;

    this.heatedBases = 0;
    this.volume = 0;
    this.formFactor = 0;
    this.branchingFactorBasically = 0;
  }
}

export class BuildingInvestment {
  wallsInvestment: number;
  roofsInvestment: number;
  windowsInvestment: number;
  groundInvestment: number;
  sumInvestment: number;
  unitPriceForWallIsolation: number;
  unitPriceForRoofsIsolation: number;
  unitPriceForWindowsIsolation: number;
  unitPriceForGroundIsolation: number;

  constructor() {
    this.wallsInvestment = 0;
    this.roofsInvestment = 0;
    this.windowsInvestment = 0;
    this.groundInvestment = 0;
    this.sumInvestment = 0;
    this.unitPriceForWallIsolation = 0;
    this.unitPriceForRoofsIsolation = 0;
    this.unitPriceForWindowsIsolation = 0;
    this.unitPriceForGroundIsolation = 0;
  }
}

export class BuildingMoneySaving {
  heatingCost: number;
  heatingCostPerArea: number;
  wallsSaving: number;
  wallsSavingPerArea: number;
  roofSaving: number;
  roofSavingPerArea: number;
  windowsSaving: number;
  windowsSavingPerArea: number;
  groundSaving: number;
  groundSavingPerArea: number;
  sumSaving: number;
  sumSavingPerArea: number;
  energyPrice: number;

  constructor() {
    this.heatingCost = 0;
    this.heatingCostPerArea = 0;
    this.wallsSaving = 0;
    this.wallsSavingPerArea = 0;
    this.roofSaving = 0;
    this.roofSavingPerArea = 0;
    this.windowsSaving = 0;
    this.windowsSavingPerArea = 0;
    this.groundSaving = 0;
    this.groundSavingPerArea = 0;
    this.sumSaving = 0;
    this.sumSavingPerArea = 0;
    this.energyPrice = 0;
  }
}

export class BuildingCO {
  transmision: number;
  decreaseByWallsIsolation: number;
  decreaseByRoofsIsolation: number;
  decreaseByWindowsIsolation: number;
  decreaseByGroundIsolation: number;
  sumDecrease: number;

  constructor() {
    this.transmision = 0;
    this.decreaseByWallsIsolation = 0;
    this.decreaseByRoofsIsolation = 0;
    this.decreaseByWindowsIsolation = 0;
    this.decreaseByGroundIsolation = 0;
    this.sumDecrease = 0;
  }
}

export class BuildingConsumation {
  yearlyRequredEnergy: number;
  wallsIsolationSaving: number;
  roofsIsolationSaving: number;
  windowsIsolationSaving: number;
  groundIsolationSaving: number;
  sumIsolationSaving: number;

  constructor() {
    this.yearlyRequredEnergy = 0;
    this.wallsIsolationSaving = 0;
    this.roofsIsolationSaving = 0;
    this.windowsIsolationSaving = 0;
    this.groundIsolationSaving = 0;
    this.sumIsolationSaving = 0;
  }
}

export class BuildingDust {
  transmision: number;
  decreaseByWallsIsolation: number;
  decreaseByRoofsIsolation: number;
  decreaseByWindowsIsolation: number;
  decreaseByGroundIsolation: number;
  sumDecrease: number;

  constructor() {
    this.transmision = 0;
    this.decreaseByWallsIsolation = 0;
    this.decreaseByRoofsIsolation = 0;
    this.decreaseByWindowsIsolation = 0;
    this.decreaseByGroundIsolation = 0;
    this.sumDecrease = 0;
  }
}

export class BuildingNMVOC {
  transmision: number;
  decreaseByWallsIsolation: number;
  decreaseByRoofsIsolation: number;
  decreaseByWindowsIsolation: number;
  decreaseByGroundIsolation: number;
  sumDecrease: number;

  constructor() {
    this.transmision = 0;
    this.decreaseByWallsIsolation = 0;
    this.decreaseByRoofsIsolation = 0;
    this.decreaseByWindowsIsolation = 0;
    this.decreaseByGroundIsolation = 0;
    this.sumDecrease = 0;
  }
}

export class BuildingNOx {
  transmision: number;
  decreaseByWallsIsolation: number;
  decreaseByRoofsIsolation: number;
  decreaseByWindowsIsolation: number;
  decreaseByGroundIsolation: number;
  sumDecrease: number;

  constructor() {
    this.transmision = 0;
    this.decreaseByWallsIsolation = 0;
    this.decreaseByRoofsIsolation = 0;
    this.decreaseByWindowsIsolation = 0;
    this.decreaseByGroundIsolation = 0;
    this.sumDecrease = 0;
  }
}

export class BuildingPricePerInvestment {
  costOfSavedKWhWalls: number;
  costOfSavedKWhRoof: number;
  costOfSavedKWhWindows: number;
  costOfSavedKWhFloors: number;
  costOfSavedKWhAllMeasures: number;

  constructor() {
    this.costOfSavedKWhWalls = 0;
    this.costOfSavedKWhRoof = 0;
    this.costOfSavedKWhWindows = 0;
    this.costOfSavedKWhFloors = 0;
    this.costOfSavedKWhAllMeasures = 0;
  }
}

export class BuildingProfitability {
  returnPeriodForWallIsolation: number;
  yieldRateForWallIsolation: number;
  returnPeriodForRoofIsolation: number;
  yieldRateForRoofIsolation: number;
  returnPeriodForWindowsIsolation: number;
  yieldRateForWindowsIsolation: number;
  returnPeriodForGroundIsolation: number;
  yieldRateForGroundIsolation: number;
  returnPeriodForAllMeasures: number;
  yieldRateForAllMeasures: number;

  constructor() {
    this.returnPeriodForWallIsolation = 0;
    this.yieldRateForWallIsolation = 0;
    this.returnPeriodForRoofIsolation = 0;
    this.yieldRateForRoofIsolation = 0;
    this.returnPeriodForWindowsIsolation = 0;
    this.yieldRateForWindowsIsolation = 0;
    this.returnPeriodForGroundIsolation = 0;
    this.yieldRateForGroundIsolation = 0;
    this.returnPeriodForAllMeasures = 0;
    this.yieldRateForAllMeasures = 0;
  }
}

export class BuildingSO2 {
  transmision: number;
  decreaseByWallsIsolation: number;
  decreaseByRoofsIsolation: number;
  decreaseByWindowsIsolation: number;
  decreaseByGroundIsolation: number;
  sumDecrease: number;

  constructor() {
    this.transmision = 0;
    this.decreaseByWallsIsolation = 0;
    this.decreaseByRoofsIsolation = 0;
    this.decreaseByWindowsIsolation = 0;
    this.decreaseByGroundIsolation = 0;
    this.sumDecrease = 0;
  }
}
